// extracted by mini-css-extract-plugin
export default {"container":"ydYOl8","headerLine":"W5BJXv","headerAi":"iyJH96","descriptionLine":"HLbuE5","closeIcon":"jPlqJH"};